// extracted by mini-css-extract-plugin
export default {"container":"ErrorBoundary_container__9uXOp","error":"ErrorBoundary_error__u4ixx","title":"ErrorBoundary_title__REb0b","description":"ErrorBoundary_description__23ide"};